import { Container } from "react-bootstrap";
import LeafDivider from "./LeafDivider";

// Shared banner for interior pages (Faq, Gallery, Franchise, Contact, etc.)
// that don't warrant a full custom hero the way Home/Camp do.
const PageHero = ({ eyebrow, title, subtitle }) => (
  <section className="page-hero">
    <Container className="container-narrow page-hero__inner">
      {eyebrow && <span className="page-hero__eyebrow">{eyebrow}</span>}
      <h1>{title}</h1>
      {subtitle && <p className="page-hero__subtitle">{subtitle}</p>}
    </Container>
    <LeafDivider tone="var(--baale-white)" />
  </section>
);

export default PageHero;
